import { __decorate } from "tslib";
// eslint-disable-next-line max-classes-per-file
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '@material/mwc-button';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { subscribe } from '../../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../../common/reactiveX/rxElement.js';
export class AdviseeSummaryOpenActionStep {
}
export class AdviseeSummaryCompletedActionStep {
}
export class AdviseeSummaryCompletedMilestone {
}
export class AdviseeSummaryIncentiveModuleStatuses {
}
export class AdviseeSummary {
    constructor() {
        this.incentiveModuleStatuses = [];
        this.openActionSteps = [];
        this.completedActionSteps = [];
        this.completedMilestones = [];
    }
}
export class AdviseeSummaryRequest {
    constructor() {
        this.status = 'INITIALIZING';
    }
}
let AdviseeSummaryElement = class AdviseeSummaryElement extends RxElement {
    constructor() {
        super(...arguments);
        this.adviseeSummary = new AdviseeSummaryRequest();
    }
    async fetchAdvisee(email, hubSlug, accessCode) {
        try {
            const params = new URLSearchParams();
            params.append('email', email);
            params.append('hub', hubSlug);
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${accessCode}`);
            const results = await fetch(new Request(`${process.env.AIMEE_SERVICES_API_URL}/blue/coaching/adviseesummary?${params}`, {
                headers,
            }));
            if (results.ok || results.status === 200) {
                this.adviseeSummary = {
                    status: 'FOUND',
                    adviseeSummary: JSON.parse(await results.text(), (key, value) => {
                        switch (key) {
                            case 'createdDate':
                            case 'completedDate':
                                if (value) {
                                    return new Date(value);
                                }
                                return value;
                            default:
                                return value;
                        }
                    }),
                };
            }
            else if (results.status === 404) {
                this.adviseeSummary = { status: 'NOT_FOUND' };
            }
            else {
                this.adviseeSummary = { status: 'ERRORED' };
            }
        }
        catch (error) {
            this.adviseeSummary = { status: 'ERRORED' };
        }
    }
    // eslint-disable-next-line class-methods-use-this
    capitalizeWords(words) {
        const capitalized = words
            .map((word) => word[0].toUpperCase() + word.substring(1))
            .join(' ');
        return capitalized;
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
    }
    render() {
        if (this.blueUser.status !== 'AUTHENTICATED') {
            return html ``;
        }
        if (this.adviseeSummary.status === 'INITIALIZING' && this.blueUser.accessToken) {
            this.fetchAdvisee(this.email, this.hubSlug, this.blueUser.accessToken);
        }
        switch (this.adviseeSummary.status) {
            case 'FOUND': {
                const advisee = this.adviseeSummary.adviseeSummary;
                // console.log('!', advisee);
                if (!advisee) {
                    return html `Errored`;
                }
                return html `
					<!-- <h1>Advisee Summary</h1> -->
					<div class="page">
						<header class="page__header">
							<div class="page__headerContainer">
								<div class="page__meta">
									<h1><span>${advisee.name}</span> @ <span>${advisee.slug}</span></h1>
									<h2>
										Contact:
										<span>${advisee.corporateEmail || advisee.personalEmail}</span>
									</h2>
								</div>
								<div class="page__score">
									<h3>
										Wellness Score
										<span
											>${!advisee.isLegacyUser
                    ? advisee.financialWellnessScore
                    : `FWA ${advisee.financialWellnessScore}`}</span
										>
									</h3>
								</div>
							</div>
						</header>
						<div class="page__body">
							${!advisee.isLegacyUser
                    ? html `
										<h3>Completed Aimee Modules</h3>
										${!advisee.incentiveModuleStatuses || !advisee.incentiveModuleStatuses.length
                        ? html `None<br /><br />`
                        : html `
													<table class="activity">
														<thead>
															<tr>
																<th class="activity__name">Module Name</th>
																<th class="activity__level">Status</th>
																<th class="activity__date">Completed On</th>
															</tr>
														</thead>
														<tbody>
															${advisee.incentiveModuleStatuses
                            .filter(a => a.completedDate !== null)
                            .map(module => html `
																		<tr>
																			<td class="activity__name">
																				${unsafeHTML(this.capitalizeWords(module.module.replace('-', ' ').split(' ')))}
																			</td>
																			<td class="activity__date">
																				${unsafeHTML(module.moduleStatus)}
																			</td>
																			<td class="activity__level">
																				${module.completedDate.toDateString()}
																			</td>
																		</tr>
																	`)}
														</tbody>
													</table>
											  `}
										<h3>Open Action Steps</h3>
										${!advisee.openActionSteps || !advisee.openActionSteps.length
                        ? html `None<br /><br />`
                        : html `
													<table class="activity">
														<thead>
															<tr>
																<th class="activity__name"></th>
																<th class="activity__date">Assigned On</th>
																<th class="activity__level">Level</th>
															</tr>
														</thead>
														<tbody>
															${advisee.openActionSteps
                            .sort((a, b) => a.associatedMilestoneLevel - b.associatedMilestoneLevel)
                            .map(actionStep => html `
																		<tr>
																			<td class="activity__name">
																				${unsafeHTML(actionStep.actionStepDescription)}
																			</td>
																			<td class="activity__date">
																				${actionStep.createdDate.toDateString()}
																			</td>
																			<td class="activity__level">
																				${actionStep.associatedMilestoneLevel}
																			</td>
																		</tr>
																	`)}
														</tbody>
													</table>
											  `}
										<h3>Completed Action Steps</h3>
										${!advisee.completedActionSteps || !advisee.completedActionSteps.length
                        ? html `None<br /><br />`
                        : html `
													<table class="activity">
														<thead>
															<tr>
																<th class="activity__name"></th>
																<th class="activity__date">Completed On</th>
																<th class="activity__level">Level</th>
															</tr>
														</thead>
														<tbody>
															${advisee.completedActionSteps
                            .sort((a, b) => a.associatedMilestoneLevel - b.associatedMilestoneLevel)
                            .map(actionStep => html `
																		<tr>
																			<td class="activity__name">
																				${unsafeHTML(actionStep.actionStepDescription)}
																			</td>
																			<td class="activity__date">
																				${actionStep.completedDate.toDateString()}
																			</td>
																			<td class="activity__level">
																				${actionStep.associatedMilestoneLevel}
																			</td>
																		</tr>
																	`)}
														</tbody>
													</table>
											  `}
										<h3>Completed Milestones</h3>
										${!advisee.completedMilestones || !advisee.completedMilestones.length
                        ? html `None<br /><br />`
                        : html `
													<table class="activity">
														<thead>
															<tr>
																<th class="activity__name"></th>
																<th class="activity__date">Completed On</th>
																<th class="activity__level">Level</th>
															</tr>
														</thead>
														<tbody>
															${advisee.completedMilestones
                            .sort((a, b) => b.milestoneLevel - a.milestoneLevel)
                            .map(milestone => html `
																		<tr>
																			<td class="activity__name">
																				${unsafeHTML(milestone.milestoneDescription)}
																			</td>
																			<td class="activity__date">
																				${milestone.completedDate.toDateString()}
																			</td>
																			<td class="activity__level">${milestone.milestoneLevel}</td>
																		</tr>
																	`)}
														</tbody>
													</table>
											  `}
								  `
                    : ''}
						</div>
					</div>
				`;
            }
            case 'NOT_FOUND':
                return html `Not Found`;
            case 'INITIALIZING':
            case 'LOADING':
                return html `<loading-spinner></loading-spinner>`;
            case 'ERRORED':
            default:
                return html `Errored`;
        }
    }
};
AdviseeSummaryElement.styles = css `
		.page {
			min-width: 100%;
			min-height: 100%;
		}
		.page__header {
			background: rgb(0, 80, 124);
			background: linear-gradient(180deg, rgba(0, 80, 124, 1) 0%, rgba(7, 124, 171, 1) 100%);
			color: #fff;
			padding: 40px 0 120px;
		}
		.page__header h1 {
			margin: 0 0 10px;
			padding: 0;

			font-family: Helvetica, Arial, sans-serif;
			text-transform: uppercase;
			font-size: 24px;
			font-weight: normal;
		}
		.page__header h2 {
			font-family: Helvetica, Arial, sans-serif;
			text-transform: uppercase;
			margin: 0;
			padding: 0;
			font-size: 16px;
			font-weight: normal;
		}
		.page__header h3 {
			margin: 0;
			padding: 0;
			font-size: 22px;
			font-family: Helvetica, Arial, sans-serif;
			text-transform: uppercase;
			font-weight: normal;
		}
		.page__header h3 span {
			display: block;
			font-size: 32px;
		}
		.page__headerContainer {
			margin: 0 auto;
			max-width: 800px;
			padding: 0 65px;
			box-sizing: border-box;
			display: flex;
		}
		.page__meta {
			padding-right: 30px;
		}
		.page__score {
			flex: 0 0 200px;
			text-align: right;
		}
		.page__body {
			margin: -90px auto 90px;
			max-width: 800px;
			background: #fff;
			position: relative;
			padding: 53px 65px;
			box-sizing: border-box;
			border-radius: 15px;
			box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
		}
		.page__body h3 {
			margin: 0 0 10px;
			padding: 0;
			font-size: 22px;
			color: #073853;
			font-family: Helvetica, Arial, sans-serif;
			text-transform: uppercase;
			font-weight: normal;
		}
		.activity {
			width: 100%;
			font-size: 16px;
			margin-bottom: 30px;
			border-spacing: 0px;
		}
		.activity th {
			color: #fff;
			background: #007cab;
			padding: 8px 20px;
			font-family: Helvetica, Arial, sans-serif;
			font-weight: normal;
			text-transform: uppercase;
		}
		.activity tr:nth-child(odd) {
			background: #f7f7fa;
		}
		.activity td {
			padding: 8px 20px;
		}
		.activity__date {
			width: 160px;
			text-align: center;
		}
		.activity__level {
			text-align: center;
		}
		.activity__name {
			text-align: left;
		}
	`;
__decorate([
    property()
], AdviseeSummaryElement.prototype, "email", void 0);
__decorate([
    property()
], AdviseeSummaryElement.prototype, "hubSlug", void 0);
__decorate([
    state()
], AdviseeSummaryElement.prototype, "adviseeSummary", void 0);
__decorate([
    subscribe(),
    state()
], AdviseeSummaryElement.prototype, "blueUser", void 0);
AdviseeSummaryElement = __decorate([
    customElement('advisee-summary')
], AdviseeSummaryElement);
export { AdviseeSummaryElement };
//# sourceMappingURL=adviseeSummary.js.map